export const environment = {
    DISCOUNT_BRANDS_FILE_URL: null,
    PRODUCT_CATEGORIES_FILE_URL: null,
    REST_ENDPOINT: 'https://development-backend.fashion.cloud',
    LOCATION_SERVICE_URL: 'https://development-backend.fashion.cloud/location-service',
    CRM_SERVICE_URL: 'https://development-backend.fashion.cloud/crm-service',
    DIM_ADMIN_API_URL: 'https://dim-admin-api.development.fashion.cloud',
    PD_OBSERVER_URL: 'https://pd-observer.development.fashion.cloud',
    SEGMENT_ENABLED: 'FALSE',
    SEGMENT_KEY: 'uSMKJDYuJOwmIYoJOaTJvvFY6KF9RN8F', // gitleaks:allow
    USERCENTRICS_SETTINGS_ID: 'ExBTOhsk7',
    USERCENTRICS_DRAFT_PREVIEW_ENABLED: false,
    USER_BRAND_VISIBILITY_FILE_URL: null,
    ORGANIZATION_FEATURE_FLAGS_FILE_URL: null,
    CATEGORIES_CONFIGURATION_FILE_URL: null,
    AMS_STACK_MAINTENANCE_FILE_URL: null,
    FLAGSMITH_ENVIRONEMT_ID: 'Yoxptif8oPLs6ucJ9ATqgZ', // gitleaks:allow
    FLAGSMITH_URL: 'https://flagsmith-api.fashion.cloud/api/v1/',
    production: true,
    beta: true,
    DD_ENABLED: true,
    DD_RUM_ENABLED: true,
    DD_SESSION_SAMPLE_RATE: 100,
    DD_SESSION_REPLAY_SAMPLE_RATE: 100,
    DD_TRACE_SAMPLE_RATE: 0,
    DD_ENV: 'development',
    DD_CLIENT_TOKEN: 'pubdfe91d326c9b49ad6d197e95920fdd53', // gitleaks:allow
    DD_SITE: 'datadoghq.com',
    DD_APPLICATION_ID: '96466f77-e1fa-4b59-a3b5-0ea67d4079d4',
    DD_ALLOWED_TRACING_URLS: ['https://development.fashion.cloud', 'https://development-backend.fashion.cloud/'],
    CUBEJS_URL: 'https://cube.development.fashionexchange.nl',
    VERSION: process.env.APP_VERSION,
    auth0: {
        domain: 'auth.development.fashion.cloud',
        clientId: 'uzEEPm3y0RNoAT5NeGt5YMGaLFVX91Pj', // gitleaks:allow
        authorizationParams: {
            audience: 'https://development-backend.fashion.cloud/'
        }
    }
};
